export default {
  autoRuleSearch: {
    url: 'operationads/autoRule/search ',
    method: 'post',
    desc: '自动规则查询'
  },
  autoRuleSearchDetails: {
    url: 'operationads/autoRule/searchDetails ',
    method: 'post',
    desc: '应用详情分页查询'
  },
  addAutoRule: {
    url: 'operationads/autoRule/add ',
    method: 'post',
    desc: '新增规则集'
  },
  modifyAutoRule: {
    url: 'operationads/autoRule/modify',
    method: 'post',
    desc: '编辑规则集'
  },
  deleteAutoRule: {
    url: 'operationads/autoRule/delete ',
    method: 'post',
    desc: '删除规则集'
  },
  settingAutoRuleSetting: {
    url: 'operationads/autoRule/setting ',
    method: 'post',
    desc: '应用规则集'
  },
  autoSettingList: {
    url: 'operationads/report/search/autoSettingList ',
    method: 'post',
    desc: '规则集列表'
  },
  autoRuleAdGroupList: {
    url: 'operationads/autoRule/adGroup/list ',
    method: 'post',
    desc: '应用规则分页-广告组筛选'
  },
  autoRuleCampaignList: {
    url: 'operationads/autoRule/campaign/list ',
    method: 'post',
    desc: '应用规则分页-广告活动筛选'
  },
  getReviewList: {
    url: 'operationads/autoRule/getReviewList ',
    method: 'post',
    desc: '手动审核查询'
  },
  reviewOperation: {
    url: 'operationads/autoRule/reviewOperation ',
    method: 'post',
    desc: '审核操作'
  },
  getHistoryLog: {
    url: 'operationads/autoRule/getHistoryLog ',
    method: 'post',
    desc: '日志查询'
  },
  getRuleList: {
    url: 'operationads/autoRule/getRuleList ',
    method: 'post',
    desc: '日志、审核弹框规则集下拉查询'
  },
}
